import React from "react";

import SVGIcon from "../Images/SVGIcon";
import styles from "./style.module.css";

const UnpaidInvoiceBanner = () => {
  return (
    <div className={styles.container}>
      <div className={styles.contentContainer}>
        <SVGIcon src="components/v2/yellowWarningIcon.svg" className={styles.warningIcon} />
        <span className={styles.content}>
          Your account has overdue invoices. Please clear them to enjoy uninterrupted access to VideoOS.
        </span>
      </div>
    </div>
  );
};

export default UnpaidInvoiceBanner;
